import type { DeepReadonly, ShallowRef } from 'vue'
import type { ImportObject } from '@/ui-core/types'

export interface LocaleMessages {
  fieldClearButtonAriaLabel?: string
  selectControlClearButtonAriaLabel?: string
  selectControlToggleButtonLabel?: string
}

export type Messages = Record<string, LocaleMessages>

export interface Config {
  iconImportObject?: ImportObject
  avatarDefaultSrc?: string
  teleportTo?: string
  locale?: string
  normalizePath?: (
    path: string,
    options?: {
      locale?: string
    }
  ) => string
  messages?: Messages
}

export const PREDEFINED_CONFIG = {
  iconImportObject: {},
  teleportTo: 'body',
  locale: 'en',
  normalizePath: (path: string) => path,
  messages: {
    ru: {
      fieldClearButtonAriaLabel: 'Очистить',
      selectControlClearButtonAriaLabel: 'Очистить',
      selectControlToggleButtonLabel: 'Переключить выпадающий список'
    },
    en: {
      fieldClearButtonAriaLabel: 'Clear',
      selectControlClearButtonAriaLabel: 'Clear',
      selectControlToggleButtonLabel: 'Toggle dropdown'
    }
  }
} satisfies Config

export type ConfigMerged = typeof PREDEFINED_CONFIG & Config
export type UpdateConfig = (config: Partial<Config>) => void

export interface ConfigInjectionValue {
  config: DeepReadonly<ShallowRef<ConfigMerged>>
  updateConfig: UpdateConfig
}

export const CONFIG_INJECTION_KEY = '__LVL_IO_UI_CONFIG_INJECTION_KEY__'
